"use strict";

 angular.module('app.env', [])

.constant('envDeployment', {deploymentUUID:'9b7fd91f-9138-4d06-b8a5-72266b45ca62'})

;